<div class="title">{{title}}</div>
<div class="info">
	<div class="value">{{text}}</div>
	<div class="icon-wrapper">
		<hum-icon [icon]="icon"></hum-icon>
	</div>
</div>
